import './fileDrive.css';
import React, { useEffect, useRef, useState } from 'react';
import { Popover, OverlayTrigger } from "react-bootstrap";
import { FileDrive } from "./FileDrive";
import { useAppSelector } from '../../redux/hooks';
import { lddStateObject, setIndicators } from '../../redux/reducer';
import { useDispatch } from 'react-redux';
import { StateTypeContext } from '../clientportal/types';
import PortalService from '../clientportal/services/portal.service';
import { getDataReader, RPWDataReader } from '../../livedataFuncs';

const DriveTab = ({SessionID, AppCode, UserID, isCollege}) => {
  const dispatch = useDispatch();
  const [showMyDrive, setShowMyDrive] = useState(false);
  const livedataRootContainer = useAppSelector((state: lddStateObject) => state?.currentNavigation.livedataRootContainer);
  let DataReaderObj: RPWDataReader = getDataReader(livedataRootContainer?.dataRoot);
  const matterNumber = DataReaderObj?.getFileNumber();
  const AppID = DataReaderObj?.getAppId();
  const PortalID = DataReaderObj?.getClientConnectId();
  const popoverRef = useRef<HTMLDivElement>(null);
  const portalState: StateTypeContext = { appCode: AppCode, appId: AppID, page: -1, portalId: PortalID, processor: null };
  const portalService = new PortalService(portalState);
  const Indicators = useAppSelector((g: lddStateObject) => g.Indicators);

  const popover = (
    <Popover className="drive-container">
      <FileDrive
        ref={popoverRef}
        closeMyDrive={() => setShowMyDrive(false)}
        SessionID={SessionID}
        AppCode={AppCode}
        UserID={UserID}
        matterNumber={matterNumber}
        AppID={AppID} 
        portalState={portalState}
        portalService={portalService}
        FileDriveIndicators={Indicators} />
    </Popover>
  );

  useEffect(() => {
    if (popoverRef.current && Indicators.MyDriveHasNewDoc) {
      dispatch(setIndicators("MyDriveHasNewDoc", false));
    }
  }, [Indicators])
  const toggleHandler = (toggleToShow: boolean) => {
    setShowMyDrive(toggleToShow);
    if (toggleToShow && Indicators.MyDriveHasNewDoc) {
      dispatch(setIndicators("MyDriveHasNewDoc", false));
    }
  }

  return (
    (!isCollege && <OverlayTrigger
        trigger="click"
        placement="left-start"
    //   Closeroot
      show={showMyDrive}
      overlay={popover}
      onToggle={toggleHandler}>
      <div className="tab drive-tab">
        <i className="fa-duotone fa-folders"></i>
        <span>MyDrive</span>
        <i style={{ padding: "unset" }}
          className={`indicator indicator-warn ${Indicators.MyDriveHasNewDoc ? "show" : ""}`} />
      </div>
    </OverlayTrigger>)
  )
};

export default DriveTab;